














































import { TermSuccessDataPoint } from '@empathybroker/tsclient-stats/dist/models/termsuccessreport/termsuccessdata-point';

import { KpiEnum } from '../../../enums';

import { UiIconButton, UiProgressLinear } from '../../keen-ui';
import KpiArcChart from '../../kpi-arc-chart.component.vue';
import KpiBar from '../../kpi-bar.component.vue';
import TransitionHeight from '../../transition-height.component.vue';

export default {
  name: 'keyword-details',
  props: {
    data: {
      type: Object, // KeywordData
      required: true
    },
    messages: {
      type: Object,
      required: true
    }
  },
  components: {
    UiProgressLinear,
    KpiBar,
    UiIconButton,
    TransitionHeight,
    KpiArcChart
  },
  data: function () {
    return {
      baseClass: 'epb-keyword-details',
      expandedQueriesIds: [],
      detailsKpis: [KpiEnum.FINDABILITY, KpiEnum.ADD2CART, KpiEnum.NO_RESULTS],
      KpiEnum
    };
  },
  methods: {
    getQueryCountText: function (count: number): string {
      return this.$epb.utils.formatNumber(count, { maximumFractionDigits: 2 }, true);
    },
    getKpiData: function (kpi: KpiEnum, queryData: TermSuccessDataPoint) {
      const kpiMessages = this.getKpiMessages(kpi);
      const labelFn = {
        [KpiEnum.QUERIES]: () => kpiMessages.valueLabel,
        [KpiEnum.NO_RESULTS]: () => kpiMessages.valueLabel,
        default: () => kpiMessages.percentageLabel
      };
      const label = (labelFn[kpi] || labelFn.default)();

      const kpiValueIds = this.getKpiValueIds(kpi);
      const percentageFn = {
        [KpiEnum.QUERIES]: () => ((queryData[kpiValueIds.count] / this.data.overall.queryCount) * 100),
        [KpiEnum.NO_RESULTS]: () => ((queryData[kpiValueIds.count] / queryData[this.getKpiValueIds(KpiEnum.QUERIES).count]) * 100),
        default: () => queryData[kpiValueIds.pct]
      };
      const percentage = (Math.round((percentageFn[kpi] || percentageFn.default)() * 100) / 100);

      return {
        id: kpi,
        label,
        valueLabel: kpiMessages.valueLabel,
        percentage,
        count: queryData[kpiValueIds.count]
      };
    },
    getKpiValueIds: function (kpi: KpiEnum) {
      return {
        [KpiEnum.QUERIES]: () => ({
          count: 'queryCount'
        }),
        [KpiEnum.FINDABILITY]: () => ({
          pct: 'successCountPct',
          count: 'successCount'
        }),
        [KpiEnum.ADD2CART]: () => ({
          pct: 'add2cartCountPct',
          count: 'add2cartCount'
        }),
        [KpiEnum.NO_RESULTS]: () => ({
          count: 'queryCountNoResults'
        })
      }[kpi]();
    },
    getKpiMessages: function (kpi: KpiEnum) {
      const kpisMessages = this.$epb.messages.analytics.kpis;
      return {
        [KpiEnum.QUERIES]: () => kpisMessages[KpiEnum.QUERIES],
        [KpiEnum.NO_RESULTS]: () => kpisMessages.noResults,
        [KpiEnum.ADD2CART]: () => kpisMessages[KpiEnum.ADD2CART],
        [KpiEnum.FINDABILITY]: () => kpisMessages[KpiEnum.FINDABILITY],
        [KpiEnum.CLICKS]: () => kpisMessages[KpiEnum.CLICKS],
        [KpiEnum.CHECKOUT]: () => kpisMessages[KpiEnum.CHECKOUT]
      }[kpi]();
    },
    getIconButtonClasses: function (queryId: string): (string | Record<string, boolean>)[] {
      return [
        `${ this.baseClass }__icon-button`,
        `${ this.baseClass }__icon-button--expand-query eicon`,
        { [`${ this.baseClass }__icon-button--query-expanded`]: this.isQueryExpanded(queryId) }
      ];
    },
    isQueryExpanded: function (queryId: string): boolean {
      return this.expandedQueriesIds.includes(queryId);
    },
    onExpandQuery: function (queryId: string): void {
      const indexOfExpandedQueryId = this.expandedQueriesIds.indexOf(queryId);
      if (indexOfExpandedQueryId < 0) {
        this.expandedQueriesIds.push(queryId);
      } else {
        this.expandedQueriesIds.splice(indexOfExpandedQueryId, 1);
      }
    }
  }
};
